/** API due date format: DD MM YYYY (e.g. "12 10 2026") */
export const formatDueDateForApi = (isoDate: string): string | undefined => {
  if (!isoDate?.trim()) return undefined;
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return undefined;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
};

/** Parse API due date to YYYY-MM-DD for date inputs */
export const parseDueDateFromApi = (apiDate: string | null | undefined): string => {
  if (!apiDate?.trim()) return '';
  const parts = apiDate.trim().split(/\s+/);
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  return apiDate;
};

export const formatDueDateDisplay = (apiDate: string | null | undefined): string => {
  const iso = parseDueDateFromApi(apiDate);
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return apiDate ?? '—';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase();
};
